const initialState = {
    isAuthenticated: false,
    user: null
  };
export const AuthReducer = (state = initialState,action)=>{
    switch(action.type){
        case 'LOGIN':
            return {isAuthenticated:true,user:"akram"}
        case 'LOGOUT':
            return initialState
        default:
            return state
    }
}